/** Дозволені формати для опису курсу (відповідає whitelist на сервері). */
export const formatsCourseAbout = ["header", "bold", "italic", "underline", "list", "softbreak"];
